import { getTeams } from "core-integration/src/store/teams/reducers";
import { Checkbox } from "plos/src/components/forms/ReactHookFormControlled/Checkbox";
import { Select } from "plos/src/components/forms/ReactHookFormControlled/Select";
import { TextField } from "plos/src/components/forms/ReactHookFormControlled/TextField";
import Link from "plos/src/components/links/Link";
import { contentMain } from "plos/src/layouts";
import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { onboarding, onboardingTitle, termsLink } from "../onboarding.css";
import { EntryDetailsFormData } from "../types";

const EntryDetailsForm = ({
  control,
}: {
  control: Control<EntryDetailsFormData>;
}) => {
  const { t } = useTranslation("onboarding");
  const teams = useSelector(getTeams);

  return (
    <form className={onboarding}>
      <div className={contentMain}>
        <h1 className={onboardingTitle}>
          {t("welcomeMessage", "Welcome to Fantasy Premier League 26/27!")}
        </h1>
        <TextField
          control={control}
          name="name"
          label={t(
            "teamName.label",
            "Pick your team name (maximum 20 characters)",
          )}
          placeholder={t("teamName.placeholder", "Enter Name Here")}
          maxLength={20}
          rules={{
            required: t("teamName.required", "A team name is required"),
          }}
          description={t("teamName.description", "You can update this later")}
        />
        <Select
          control={control}
          name="favourite_team"
          id="favourite-club"
          label={t("favouriteTeam.label", "Choose your favourite club")}
          rules={{
            required: t(
              "favouriteTeam.required",
              "A favourite club is required",
            ),
          }}
        >
          {teams.map(({ id, name: teamName }) => (
            <option key={id} value={id}>
              {teamName}
            </option>
          ))}
          <option key="none" value={-1}>
            {t("favouriteTeam.none", "None")}
          </option>
        </Select>
        <Checkbox
          name="terms_agreed"
          control={control}
          rules={{ required: true }}
          label={t(
            "termsAndConditions.label",
            "I accept the Terms & Conditions.",
          )}
        >
          {t("termsAndConditions.label", "I accept the Terms & Conditions.")}
        </Checkbox>
        <Link
          to="/help/terms"
          target="_blank"
          rel="noopener noreferrer"
          className={termsLink}
        >
          {t(
            "termsAndConditions.readFullTerms",
            "Read the full Terms & Conditions",
          )}
        </Link>
        <p>
          {t(
            "teamDetailsForm.fantasyUpdates",
            "By creating a Fantasy team you will automatically receive updates relating to Fantasy if you are already opted into our general Premier League emails.",
          )}
        </p>
      </div>
    </form>
  );
};

export default EntryDetailsForm;
